<!-- SIDENAV HEADER -->
<div
  fxLayout="column"
  fxLayoutAlign="space-between start"
  class="header p-24 pb-4"
  ngClass="mat-accent-bg"
  ngClass.gt-md="white-fg"
>
  <div fxLayout="row" fxLayoutAlign="start center" style="padding-top: 14px">
    <button
      class="mr-0 mr-sm-16"
      mat-icon-button
      [routerLink]="this.getBackURL()"
      aria-label="Back to Reports"
      matTooltip="Back to Reports"
    >
      <mat-icon class="white-fg">arrow_back</mat-icon>
    </button>
  
    <div fxLayout="column" fxLayoutAlign="start start" *fuseIfOnDom>
      <div class="logo-text h1">Report</div>
    </div>
  </div>
</div>
<!-- / SIDENAV HEADER -->

<!-- SIDENAV CONTENT -->
<form
  [formGroup]="optionsForm"
  fxLayout="column"
  fxFlex
  style="overflow-y: auto; margin-top:4px"
>
  <div class="content" fusePerfectScrollbar *fuseIfOnDom >
    <div class="nav">
      <div class="nav">
        <div id="reportTypeFilters" class="nav-subheader pl-20 h-24">
          RECORD TYPE
        </div>
        <div class="filter-group" style="margin-bottom: 15px">
          <mat-radio-group
            formControlName="reportTypeFilter"
            (change)="change($event)"
            aria-labelledby="reportTypeFilters"
          >
            <mat-radio-button value=""><span class="reportTypeFilterItem">Cases</span></mat-radio-button>
            <mat-radio-button value="referrals"><span class="reportTypeFilterItem">Referrals</span></mat-radio-button>
            <mat-radio-button value="both"><span class="reportTypeFilterItem">Both</span></mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <div class="nav-subheader pl-20 h-24 pt-16 pb-24">FILTERS</div>

      <mat-form-field *ngIf="showOrganisationFilter">
        <mat-label>{{ organisationFilterName }}</mat-label>
        <mat-select          
          multiple
          formControlName="organisations"
          (openedChange)="openedOrganisationsChange($event)"
          class="dropdownFilter"
        >
          <mat-option
            *ngIf="organisationList?.length > 1"
            #allOrganisationsSelected
            (click)="toggleOrganisationsAllSelection()"
            [value]="0"
            style="border-bottom: 1px solid; border-color: lightgray"
            >Select All</mat-option
          >
          <mat-option
            *ngFor="let organisation of organisationList"
            [value]="organisation.filterValue"
            (click)="toggleOrganisationsPerOne()"
            >{{ organisation.filterName }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="showFilter">
        <mat-label>{{ filterName }}</mat-label>
        <mat-select          
          multiple
          formControlName="filters"
          (openedChange)="openedChange($event)"
          class="dropdownFilter"
        >
          <mat-option
            *ngIf="filterList.length > 1"
            #allSelected
            (click)="toggleFiltersAllSelection()"
            [value]="0"
            style="border-bottom: 1px solid; border-color: lightgray"
            >Select All</mat-option
          >
          <mat-option
            *ngFor="let filter of filterList"
            [value]="filter.filterValue"
            (click)="toggleFiltersPerOne()"
            >{{ filter.filterName }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <div *ngIf="showSingleSelectionFilter" class="nav">
        <div class="filter-group pt-8" style="padding-bottom: 5px">
          <div
            id="singleSelectionFilterLabel"
            class="nav-subheader h-24"
            style="margin-left: -24px !important; padding-bottom: 5px"
          >
            RATE PER STAFF
          </div>
          <mat-radio-group
            formControlName="singleSelectionFilter"
            (change)="singleSelectionFilterChange($event)"
            aria-labelledby="singleSelectionFilter"
            class="dropdownFilter"
          >
            <mat-radio-button
              *ngFor="let filter of filterList"
              [value]="filter.filterValue"
              >{{ filter.filterName }}</mat-radio-button
            >
          </mat-radio-group>
        </div>
      </div>
    </div>

    <div *ngIf="showSubFilter" class="nav">
      <mat-form-field>
        <mat-label>{{ subFilterName }}</mat-label>
        <mat-select          
          multiple
          formControlName="subFilters"
          (openedChange)="openedSubFilterChange($event)"
          class="dropdownFilter"
        >
          <mat-option
            *ngIf="subFilterList.length > 1"
            #allSubFiltersSelected
            (click)="toggleSubFiltersAllSelection()"
            [value]="0"
            style="border-bottom: 1px solid; border-color: lightgray"
            >Select All</mat-option
          >
          <mat-option
            *ngFor="let filter of subFilterList"
            [value]="filter.filterValue"
            (click)="toggleSubFiltersPerOne()"
            >{{ filter.filterName }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>

    <div *ngIf="showUserFilter" class="nav">
      <mat-form-field>
        <mat-label>{{ userFilterName }}</mat-label>        
        <mat-select          
          multiple
          formControlName="users"
          (openedChange)="openedUsersChange($event)"
          class="dropdownFilter"
        >
          <mat-option
            *ngIf="userList?.length > 1"
            #allUsersSelected
            (click)="toggleUsersAllSelection()"
            [value]="0"
            style="border-bottom: 1px solid; border-color: lightgray"
            >Select All</mat-option
          >
          <mat-option
            *ngFor="let user of userList"
            [value]="user.filterValue"
            (click)="toggleUsersPerOne()"
            >{{ user.filterName }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>

    <div class="nav" *ngIf="!showTaskDateFilter && showStateFilter">
      <mat-form-field>
        <mat-label>State</mat-label>        
        <mat-select          
          formControlName="stateFilter"
          (selectionChange)="change($event)"
          class="dropdownFilter"
        >
          <mat-option value="">Any</mat-option>
          <mat-option
            *ngFor="let state of stateList"
            [value]="state.name.toLowerCase()"
            >{{ state.name }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>

    <div *ngIf="showReferralDateFilter" class="nav">
      <div id="datefilters" class="nav-subheader pl-20 h-24">DATE FILTERS</div>
      <div class="filter-group pt-8">
        <mat-radio-group
          *ngIf="showDateFilterOptions"
          formControlName="dateFilter"
          (change)="change($event)"
          aria-labelledby="datefilters"
          class="dropdownFilter"
        >
          <mat-radio-button value="">No Date Filter</mat-radio-button>
          <mat-radio-button value="dateReferred">Date Referred</mat-radio-button>
          <mat-radio-button value="dateOpened">Date Opened</mat-radio-button>
          <mat-radio-button value="dateClosed">Date Closed</mat-radio-button>
        </mat-radio-group>
        <div class="pt-16">
          <app-intec-date-picker
            class="form-control datepicker dropdownFilter"
            [placeholder]="fromDatePlaceholder"
            formControlName="dateFrom"
            (dateChange)="fromDateChange($event)"
          ></app-intec-date-picker>
          <app-intec-date-picker
          class="form-control datepicker dropdownFilter"
            [placeholder]="toDatePlaceholder"
            formControlName="dateTo"
            (dateChange)="toDateChange($event)"
          ></app-intec-date-picker>
        </div>
      </div>
    </div>

    <div *ngIf="showTaskDateFilter && !showReferralDateFilter" class="nav">
      <div id="datefilters" class="nav-subheader pl-20 h-24">DATE FILTERS</div>
      <div class="filter-group pt-8">
        <mat-radio-group
          *ngIf="showDateFilterOptions"
          formControlName="dateFilter"
          (change)="change($event)"
          aria-labelledby="datefilters"
        >
          <mat-radio-button value="">No Date Filter</mat-radio-button>
          <mat-radio-button value="dateDue">Date Due</mat-radio-button>
          <mat-radio-button value="dateCreated">Date Created</mat-radio-button>
          <mat-radio-button value="dateCompleted">Date Completed</mat-radio-button>
          <mat-radio-button *ngIf="hasDateIncurred" value="dateIncurred">{{dateIncurredLabel}}</mat-radio-button>
        </mat-radio-group>
        <div class="pt-16">
          <app-intec-date-picker
            class="form-control datepicker dropdownFilter"
            [placeholder]="fromDatePlaceholder"
            formControlName="dateFrom"
            (dateChange)="fromDateChange($event)"
          ></app-intec-date-picker>
          <app-intec-date-picker
            class="form-control datepicker dropdownFilter"
            [placeholder]="toDatePlaceholder"
            formControlName="dateTo"
            (dateChange)="toDateChange($event)"            
          ></app-intec-date-picker>
        </div>
      </div>
    </div>

    <div class="nav" *ngIf="!showTaskDateFilter && !showReferralDateFilter">
      <div id="datefilters" class="nav-subheader pl-20 h-24">DATE FILTERS</div>
      <div class="filter-group pt-8">
        <mat-radio-group
          *ngIf="showDateFilterOptions"
          formControlName="dateFilter"
          (change)="change($event)"
          aria-labelledby="datefilters"
        >
          <mat-radio-button value=""> No Date Filter </mat-radio-button>
          <mat-radio-button value="dateOpened"> Date Opened </mat-radio-button>
          <mat-radio-button value="dateClosed"> Date Closed </mat-radio-button>
          <mat-radio-button *ngIf="hasDateIncurred" value="dateIncurred">{{ dateIncurredLabel }}</mat-radio-button>
        </mat-radio-group>
        <div class="pt-16">
          <app-intec-date-picker
            class="form-control datepicker dropdownFilter"
            [placeholder]="fromDatePlaceholder"
            formControlName="dateFrom"
            (dateChange)="fromDateChange($event)"            
          ></app-intec-date-picker>
          <app-intec-date-picker
            class="form-control datepicker dropdownFilter"
            [placeholder]="toDatePlaceholder"
            formControlName="dateTo"
            (dateChange)="toDateChange($event)"            
          ></app-intec-date-picker>
        </div>
      </div>
    </div>

    <div class="nav mt-24" *ngIf="showIncludeArchive">
      <mat-checkbox
        class="my-8 pl-24"
        id="chkIncludeArchived"
        formControlName="includeArchived"
        name="includeArchived"
        (change)="change($event)"
        >Include Archived</mat-checkbox
      >
    </div>

    <div class="p-24">
      <button
        *ngIf="hasData"
        mat-raised-button
        fxFlex
        class="mat-accent add-task-button"
        (click)="applyOptions()"
        aria-label="APPLY FILTERS"
        matTooltip="Apply Filters"
        [disabled]="!report || !hasChanges"
      >
        APPLY FILTERS
      </button>
      <button
        *ngIf="!hasData"
        mat-raised-button
        fxFlex
        class="mat-accent add-task-button"
        (click)="applyOptions()"
        aria-label="CREATE REPORT"
        matTooltip="Create Report"
        [disabled]="!report || !hasChanges"
      >
        CREATE REPORT
      </button>
    </div>
  </div>
</form>
<!-- / SIDENAV CONTENT -->
